import { ScrollView } from 'devextreme-react/scroll-view'
import { Accordion, Item as AccordionItem } from 'devextreme-react/accordion'
import { List } from 'devextreme-react/list'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './WhatsNew.module.scss'

export type WhatsNewUpdate = {
  id: number
  title: string
  date?: string
  type: 'feature' | 'enhancement' | 'technical'
  items: string[]
}

export const WhatsNew = () => {
  const recentUpdates: WhatsNewUpdate[] = [
    {
      id: 1,
      title: '📅 Calendario',
      type: 'technical',
      items: [
        'Possibilità di ordinare i calendari a piacimento',
        'Possibilità di creare gruppi di calendari a piacimento',
        'Possibilità di cambiare colore ai calendari a piacimento',
        'Colori sul calendario con trasparenza',
      ],
    },
    {
      id: 2,
      title: '🔧 Ottimizzazioni Tecniche',
      type: 'technical',
      items: ['Sistemati vari bug segnalati dagli utenti'],
    },
  ]

  const getTypeColor = (type: string) => {
    switch (type) {
      case 'feature':
        return styles.typeFeature
      case 'enhancement':
        return styles.typeEnhancement
      case 'technical':
        return styles.typeTechnical
      default:
        return styles.typeDefault
    }
  }

  const getTypeIcon = (type: string) => {
    switch (type) {
      case 'feature':
        return 'star'
      case 'enhancement':
        return 'arrow-up'
      case 'technical':
        return 'cog'
      default:
        return 'info-circle'
    }
  }

  const getTypeLabel = (type: string) => {
    switch (type) {
      case 'feature':
        return 'Nuova Funzionalità'
      case 'enhancement':
        return 'Miglioramento'
      case 'technical':
        return 'Ottimizzazione Tecnica'
      default:
        return 'Aggiornamento'
    }
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.title}>
          <FontAwesomeIcon icon={['fas', 'sparkles']} className={styles.titleIcon} />
          Novità e Aggiornamenti
        </div>
        <p className={styles.subtitle}>Scopri le ultime funzionalità e miglioramenti aggiunti all&apos;applicazione</p>
      </div>

      <ScrollView className={styles.scrollContainer} height="100%" showScrollbar="onScroll">
        <div className={styles.content}>
          <Accordion className={styles.accordion} collapsible={true} multiple={true} animationDuration={300}>
            {recentUpdates.map((update) => (
              <AccordionItem key={update.id} title={update.title}>
                <div className={styles.updateContent}>
                  <div className={styles.updateHeader}>
                    <div className={`${styles.updateType} ${getTypeColor(update.type)}`}>
                      <FontAwesomeIcon icon={['fas', getTypeIcon(update.type)]} className={styles.typeIcon} />
                      <span className={styles.typeLabel}>{getTypeLabel(update.type)}</span>
                    </div>
                    {/* <span className={styles.updateDate}>{update.date}</span> */}
                  </div>

                  <List
                    className={styles.featureList}
                    dataSource={update.items}
                    itemRender={(item) => (
                      <div className={styles.listItem}>
                        <FontAwesomeIcon icon={['fas', 'check-circle']} className={styles.checkIcon} />
                        <span className={styles.itemText}>{item}</span>
                      </div>
                    )}
                    showSelectionControls={false}
                    focusStateEnabled={false}
                    hoverStateEnabled={true}
                  />
                </div>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </ScrollView>

      <div className={styles.footer}>
        <div className={styles.footerContent}>
          <FontAwesomeIcon icon={['fas', 'info-circle']} className={styles.footerIcon} />
          <span className={styles.footerText}>
            Continuiamo a lavorare per migliorare la tua esperienza. Hai suggerimenti? Contatta il team di sviluppo!
          </span>
        </div>
      </div>
    </div>
  )
}
